import Vue from "vue";
import App from "./App.vue";
import "@babel/polyfill";
import router from "./router";
import store from "./store/index";
import api from "./http/api";
import ElementUI from "element-ui";
import "./style/index.scss";
import storage from "@/common/storage";
// 编辑器样式引入
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.prototype.$api = api;
Vue.prototype.$storage = storage;

Vue.config.productionTip = false;
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
